import React from 'react';
import GoldChart from '../components/GoldChart';
export default function PriceChart() { return <GoldChart height={440} fullPage />; }
